
import React, { useState } from 'react';

import useFilterForCheckbox from '../hooks/useFilterForCheckbox';

import FilterItem from './FilterItem';

/**
 * BrandFilter
 *
 * A filter that returns selected brands
 *
 * @param {Object} props
 * @param {Object} props.context
 * @param {Object} props.setStart
 * @param {string} props.dataCode
 * @param {Object} props.scrollToTop
 */
const BrandFilter = ({ data, setStart, dataCode, scrollToTop }) => {
  const [ isActive, setIsActive ] = useState( false );

  const {
    checked,
    setChecked,
    handleFilter
  } = useFilterForCheckbox( setStart, dataCode, scrollToTop );

  const brands = data.map( ( brand ) => {
    return {
      label: brand.title.rendered,
      value: brand.ACF.brand_codes
    };
  });

  return (
    brands.length > 0 && (
      <FilterItem
        data={ brands }
        setStart={ setStart }
        dataCode="data-brand-codes"
        title="Brand"
        isActive={ isActive }
        setIsActive={ setIsActive }
        checked={ checked }
        setChecked={ setChecked }
        handleFilter={ ( e, index ) => handleFilter( e, index ) }
        scrollToTop={ scrollToTop }
      />
    )

  );
};

export default BrandFilter;
